import { decodeHTML } from 'entities';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { postMABAA020 } from '../../../services/Api';
import CheckGroup from '../../../shared/components/CheckGroup';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MEMBERS } from '../../../shared/constants/app';
import { formatDateTime, formatNumberWithCommas, getCheckBoxValues } from '../../../utils';

const MABAA020 = () => {
    const [showDetails, setShowDetails] = useState(false);
    const [checkedValues, setCheckedValues] = useState({});
    const [searchCondition, setSearchCondition] = useState('');
    const [keyword, setKeyword] = useState('');
    const [size, setSize] = useState(50);
    const [listResults, setListResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const toggleDetails = () => setShowDetails(!showDetails);

    const getOptions = (name) => {
        const options = {
            MemberGbn: [
                { id: 'MemberGbn_C', label: '치과회원', value: 'c' },
                { id: 'MemberGbn_P', label: '개인회원', value: 'p' },
            ],
            AppGbnCD: [
                { id: 'AppGbnCD_501', label: '대표 치과의사', value: '501' },
                { id: 'AppGbnCD_110', label: '치과의사', value: '110' },
                { id: 'AppGbnCD_201', label: '치과기공사(소장)', value: '201' },
                { id: 'AppGbnCD_202', label: '치과기공사(기사)', value: '202' },
                { id: 'AppGbnCD_310', label: '치과위생사 및 진료스텝', value: '310' },
                { id: 'AppGbnCD_401', label: '학생(치의학과)', value: '401' },
                { id: 'AppGbnCD_402', label: '학생(치위생사)', value: '402' },
                { id: 'AppGbnCD_403', label: '학생(치기공사)', value: '403' },
                { id: 'AppGbnCD_502', label: '간호조무사', value: '502' },
                { id: 'AppGbnCD_999', label: '기타', value: '999' },
            ],
            EM_join_membership: [
                { id: 'EM_join_membership_1', label: '있음', value: '1' },
                { id: 'EM_join_membership_2', label: '없음', value: '2' },
            ],
        };
        return options[name];
    };

    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        setCheckedValues((checkedValues) => getCheckBoxValues(checkedValues, name, value, checked));
    };

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const getSize = (e) => {
        const selectedValue = e.target.value;
        setSize(selectedValue);
    };

    const getListData = (currentPage = page) => {
        postMABAA020({
            searchCondition,
            keyword: keyword?.trim(),
            options: checkedValues,
            size,
            page: currentPage,
        })
            .then(({ data }) => {
                setListResults(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [searchParams]);
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MEMBERS} />
                <div className="content-right">
                    <h1 className="title">탈퇴회원</h1>
                    <table id="table-form-option" className="table table-bordered table-has-radius">
                        <tbody>
                            <tr>
                                <th colSpan={8} className="t-left header-item">
                                    <div className="header-item-inner">
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} defaultValue={''}>
                                                <option value="">전체</option>
                                                <option value="MemberID">아이디</option>
                                                <option value="NameKor">이름</option>
                                                <option value="BizCompany">치과명</option>
                                                <option value="TelNo">연락처</option>
                                                <option value="MobileNo">핸드폰</option>
                                                <option value="Email">이메일</option>
                                                <option value="ResidentNo">생년월일</option>
                                                <option value="LicenseNo">면허번호</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어를 입력해 주세요"
                                                onChange={inputChange}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                        <div className="button-group">
                                            <button className="btn btn-primary" onClick={clickSearch}>
                                                검색
                                            </button>
                                            <button className="btn btn-dark" onClick={toggleDetails}>
                                                상세검색
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            {showDetails && (
                                <>
                                    <tr>
                                        <th colSpan={1}>
                                            <span>회원그룹</span>
                                        </th>
                                        <td colSpan={7}>
                                            <div>
                                                <CheckGroup
                                                    name="MemberGbn"
                                                    options={getOptions('MemberGbn')}
                                                    checkedValues={checkedValues.MemberGbn}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colSpan={1}>
                                            <span>회원구분</span>
                                        </th>
                                        <td colSpan={7}>
                                            <div className="group-checkBox">
                                                <CheckGroup
                                                    name="AppGbnCD"
                                                    options={getOptions('AppGbnCD')}
                                                    checkedValues={checkedValues.AppGbnCD}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                    <div className="wrap-dropDown">
                        <div className="collab">
                            <div className="form-select-container">
                                <select className="select-basic" onChange={getSize} defaultValue={50}>
                                    <option value="20">20개씩 보기</option>
                                    <option className="option-placeholder" value="50">
                                        50개씩 보기
                                    </option>
                                    <option value="100">100개씩 보기</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <table
                        id="table-results-member"
                        className="table table-results-member-style2 table-bordered table-has-radius"
                    >
                        <thead>
                            <tr>
                                <td colSpan={14}>
                                    <div className="top-table">
                                        <div className="count-case">
                                            총 {formatNumberWithCommas(pages.totalRow || 0)}건
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style={{ width: '60px' }}>회원 그룹</th>
                                <th>
                                    회원 아이디
                                    <br /> (거래처 코드)
                                </th>
                                <th>이름</th>
                                <th>생년월일</th>
                                <th>핸드폰</th>
                                <th>회원 구분</th>
                                <th>치과명</th>
                                <th style={{ width: '60px' }}>
                                    탈퇴
                                    <br /> 사이트
                                </th>
                                <th>탈퇴일</th>
                                <th>
                                    탈퇴사유
                                    <br /> (탈퇴 IP)
                                </th>
                            </tr>
                            {listResults && listResults?.length > 0 ? (
                                listResults.map((item, index) => {
                                    const leaveDate = formatDateTime(item.leaveDate);
                                    const residentNoFormat = item?.residentNo
                                        ? moment(item?.residentNo, 'YYMMDD').format('YYYY.MM.DD')
                                        : '';
                                    return (
                                        <tr key={index}>
                                            <td>{item.memberGbn === 'C' ? '치과' : '개인'}</td>
                                            <td>{item?.memberID}</td>
                                            <td>{item?.nameKor}</td>
                                            <td>{residentNoFormat}</td>
                                            <td>
                                                {item?.mobileNo}
                                                <br /> {item?.telNo}
                                            </td>
                                            <td>{item?.appGbnCD || '-'}</td>
                                            <td>{item?.bizCompany || '-'}</td>
                                            <td>{item?.leaveSite}</td>
                                            <td>{leaveDate}</td>

                                            <td>
                                                {decodeHTML(item?.leaveReason)}
                                                <br />({item?.regIP})
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={10}>데이타가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <Pagination pages={pages} />
                </div>
            </div>
        </div>
    );
};

export default MABAA020;
